import { Injectable, NgZone } from '@angular/core';

/**
 * Dropdown Helper Service
 *
 * Calls a closeHandler function whenever a user clicks outside of the dropdown
 *
 */

@Injectable({
    providedIn: 'root',
})
export class DropdownHelperService {
    constructor(private ngZone: NgZone) {}

    setCloseHandler(dropdown: HTMLElement, closeHandler: Function): void {
        /**
         * When a mousedown or touchstart event is initiated outside of `element`, call `closeHandler`
         *
         * @param dropdown - The HTML of the dropdown itself
         * @param closeHandler - The function to be called when clicking outside the dropdown
         */

        // Run event listeners outside of Angular zone so that they don't trigger unnecessary change detection cycles
        this.ngZone.runOutsideAngular((): void => {
            ['mousedown', 'touchstart'].forEach((eventName: string): void => {
                document.addEventListener(
                    eventName,
                    (e: Event): void => {
                        const targetEl: HTMLElement = e.target as HTMLElement;
                        const isOutsideDropdown: boolean = !dropdown.contains(targetEl);
                        const isPageScrollbar: boolean = targetEl.tagName === 'HTML';
                        if (isOutsideDropdown && !isPageScrollbar) {
                            this.ngZone.run((): void => {
                                closeHandler(targetEl);
                            });
                        }
                    },
                    { passive: true }
                );
            });
        });
    }
}
